import type { ReactNode } from 'react';

import { IconBlanketPo } from '@procurify/ui'
import { Space, SubText } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { type UnbilledItem } from '@webapp/models'
import { APItemTypes } from '@webapp/models/enums'
import messages from './messages'
import { APUnbilledItemTagStyled } from './styles/APUnbilledItemTagStyled'

export interface IAPUnbilledItemTagProps {
  itemType: UnbilledItem['type']
}

interface IconTextMap {
  text: string
  icon: ReactNode
}

const getIconAndText = (intl, itemType): IconTextMap | null => {
  switch (itemType) {
    case APItemTypes.RECEIVE_BY_COST_BLANKET_ORDER_ITEM:
    case APItemTypes.RECEIVE_BY_QTY_BLANKET_ORDER_ITEM:
      return {
        text: intl.formatMessage(messages.blanketItemText),
        icon: <IconBlanketPo />,
      }
    default:
      return null
  }
}

export const APUnbilledItemTag = ({ itemType }: IAPUnbilledItemTagProps) => {
  const intl = useProcurifyIntl()

  const itemTypeFields = getIconAndText(intl, itemType)

  return itemTypeFields ? (
    <APUnbilledItemTagStyled>
      <Space direction='horizontal' size='xsmall'>
        {itemTypeFields.icon}
        <SubText>{itemTypeFields.text}</SubText>
      </Space>
    </APUnbilledItemTagStyled>
  ) : null
}
